import {showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {isString} from 'ramda-adjunct';

import {testIds, workshopRoutes} from '@dms/routes';
import {
  catchUnhandledDataGridActions,
  DmsDataGrid,
  PersonnelOverview,
  PersonnelOverviewWrapper,
} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

import {interestBulkOperationActionCallback} from '../../../../utils/interestBulkOperationActionCallback';

const WORKSHOP_INTEREST_PERSONNEL_OVERVIEW_FILTER_ID =
  'workshop-interest-personnel-overview-filter';

const GRID_CODE = 'workshop-interest';

type WorkshopInterestOverviewProps = {
  isPersonnelPanelOpen: boolean;
  canViewWorkshopInterest: boolean;
};

export function WorkshopInterestOverview(props: WorkshopInterestOverviewProps) {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    if (!isString(rowId)) {
      showNotification.error();
      return;
    }

    match(actionKey)
      .with('redirectDetail', 'detail', () =>
        navigate(
          composePath(workshopRoutes.interestDetailOverview, {
            params: {id: rowId},
            isSearchParamsPreserved: false,
            queryParams: sourceSearchParams,
          })
        )
      )
      .with('detail_newTab', () => {
        window.open(
          composePath(workshopRoutes.interestDetailOverview, {
            params: {id: rowId},
            isSearchParamsPreserved: false,
            queryParams: sourceSearchParams,
          })
        );
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  const isPersonnelOverviewOpen = props.isPersonnelPanelOpen && props.canViewWorkshopInterest;

  return (
    <PersonnelOverviewWrapper
      externalFilterId={
        isPersonnelOverviewOpen ? WORKSHOP_INTEREST_PERSONNEL_OVERVIEW_FILTER_ID : undefined
      }
      data-testid={testIds.workshop.interest('personnelOverviewWrapper')}
    >
      <DmsDataGrid
        gridCode={GRID_CODE}
        actionCallback={actionCallback}
        bulkOperationActionCallback={interestBulkOperationActionCallback}
        externalFilterId={WORKSHOP_INTEREST_PERSONNEL_OVERVIEW_FILTER_ID}
        filterComponent={(connectorProps) => (
          <PersonnelOverview
            entity={GRID_CODE}
            isOpen={isPersonnelOverviewOpen}
            values={connectorProps.values}
            onChange={connectorProps.onChange}
            data-testid={testIds.workshop.interest('personnelOverview')}
          />
        )}
        data-testid={testIds.workshop.interest('datagrid')}
      />
    </PersonnelOverviewWrapper>
  );
}
